import React from 'react';
import { motion } from 'framer-motion';
import { BriefcaseIcon, ShoppingBagIcon, GlobeIcon, UsersIcon, TrendingUpIcon } from 'lucide-react';
export function TargetAudience() {
  const audiences = [{
    icon: BriefcaseIcon,
    title: 'Consultores y profesionales independientes'
  }, {
    icon: UsersIcon,
    title: 'Agencias digitales y de servicios'
  }, {
    icon: ShoppingBagIcon,
    title: 'E-commerce e importadores'
  }, {
    icon: GlobeIcon,
    title: 'Negocios digitales internacionales'
  }, {
    icon: TrendingUpIcon,
    title: 'Empresarios que operan desde cualquier país'
  }];
  return <section className="w-full bg-bg-primary py-12 md:py-20 px-4" data-id="element-310">
      <div className="max-w-6xl mx-auto" data-id="element-311">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-312">
          <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-3 md:mb-6" data-id="element-313">
            Diseñado para emprendedores hispanos no residentes
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-12" data-id="element-314">
          {audiences.map((audience, index) => {
          const Icon = audience.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-bg-card border border-accent-primary border-opacity-10 rounded-lg p-4 md:p-6 hover:border-opacity-30 transition-all" data-id="element-315">
                <div className="flex items-start space-x-3 md:space-x-4" data-id="element-316">
                  <div className="flex-shrink-0" data-id="element-317">
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-accent-primary bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-318">
                      <Icon className="h-5 w-5 md:h-6 md:w-6 text-accent-primary" aria-hidden="true" data-id="element-319" />
                    </div>
                  </div>
                  <p className="text-sm md:text-base text-text-primary font-medium leading-relaxed" data-id="element-320">
                    {audience.title}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-lg md:text-xl text-text-secondary text-center max-w-3xl mx-auto leading-relaxed" data-id="element-321">
          Si buscas crear una empresa estadounidense legítima, correctamente
          estructurada y lista para operar y crecer, este es tu sistema.
        </motion.p>
      </div>
    </section>;
}